import { render, staticRenderFns } from "./RolesIndex.vue?vue&type=template&id=c99d674e&scoped=true&"
import script from "./RolesIndex.vue?vue&type=script&lang=js&"
export * from "./RolesIndex.vue?vue&type=script&lang=js&"
import style0 from "./RolesIndex.vue?vue&type=style&index=0&id=c99d674e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99d674e",
  null
  
)

export default component.exports